import script from "./GlobalLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&setup=true&lang=js"

import "./GlobalLoader.vue?vue&type=style&index=0&id=5146f072&lang=css"

const __exports__ = script;

export default __exports__